/* eslint-disable @typescript-eslint/no-explicit-any */
// The whole code is copied from VPC.

import { Messages } from '../../../gen-src/Localize';
import * as _ from 'underscore';
import { Formatters, LocaleData } from '../../../gen-src/Localize';
import { CRASSResponseMaxCount } from '../../search/services/ContentService';

export namespace L10n {
  export let language: string;
  export let locale: string;

  export function localizedCount(value: any) {
    if (value === +value) {
      // is value a numeric type?
      if (value === (value | 0)) {
        // is value an integer?
        return Formatters.formatCount(value);
      }
    }
    return value;
  }

  export function localizedFloat(value: any) {
    if (value === +value) {
      // is value a numeric type?
      return Formatters.formatFloat(value);
    }
    return value;
  }

  export function localizedPercent(value: any) {
    if (value === +value) {
      // is value a numeric type?
      return Formatters.formatPercent(value / 100);
    }
    return value;
  }

  export function localizedDateTime(value: any) {
    return formatAsDate(value, Formatters.formatMediumDateTimeWithoutSeconds);
  }

  // returns 0 for Sunday, 1 for Monday
  export function firstDayOfWeek(): number {
    return LocaleData.get().firstDayOfWeek === 'mon' ? 1 : 0;
  }

  // True if Monday, false if Sunday. Callers shouldn't need to know the int values.
  export function firstDayOfWeekIsMonday(): boolean {
    return LocaleData.get().firstDayOfWeek === 'mon';
  }

  export function is24HourTimeCycle(): boolean {
    return LocaleData.get().prefer24HourTimeCycle;
  }

  export function elideIfLong(s: string, maxLength: number = 100): string {
    const HORIZONTAL_ELLIPSIS = '\u2026';
    return s && s.length > maxLength ? s.substr(0, maxLength) + HORIZONTAL_ELLIPSIS : s;
  }
}

function formatAsDate(value: any, formatter: (date: Date) => string): string {
  if (!formatter) return '';
  if (_.isDate(value)) {
    return formatter(value);
  } else if (_.isString(value)) {
    return formatter(new Date(value));
  }
  return '';
}

// Since we can only get 10K results back from ES, any time the results from a single content type are 10K we will
// show the result as 10000+ and the total results for the mixed content will also display 10000+,
// other languages might display the plus sign differently so it has been placed in a localization file.
export function formatTotalSearchResultCount(totalCount: number, alwayShowPlusAfterNumber?: boolean): string {
  const maxCount = CRASSResponseMaxCount;

  if (totalCount === undefined) {
    return '';
  }

  if (alwayShowPlusAfterNumber) {
    return Messages.CountOver({ COUNT: Formatters.formatCount(Math.min(totalCount, maxCount)) });
  }

  return totalCount < maxCount ? Formatters.formatCount(totalCount) : Messages.CountOver10K({ COUNT: Formatters.formatCount(maxCount) });
}
